import { useState } from 'react';
import { axiosInstance } from '../App';
import { toast } from 'sonner';

export function useCnpjLookup() {
  const [loadingCNPJ, setLoadingCNPJ] = useState(false);

  const buscarCNPJ = async (digits) => {
    if (!digits || digits.length !== 14) return null;
    setLoadingCNPJ(true);
    try {
      const { data } = await axiosInstance.get(`/cnpj/${digits}`);
      return data;
    } catch (err) {
      if (err.response?.status === 404) {
        toast.warning('CNPJ não encontrado. Preencha os dados manualmente.');
      } else {
        toast.warning('Não foi possível buscar os dados do CNPJ. Preencha manualmente.');
      }
      return null;
    } finally {
      setLoadingCNPJ(false);
    }
  };

  return { buscarCNPJ, loadingCNPJ };
}
